import React from 'react';
import classNames from 'classnames';

import { Button, NamedLink } from '../../components';
import config from '../../config';

import { injectIntl } from '../../util/reactIntl';
import css from './SignupProviderForms.css';

import enImg from '../../assets/signup-intro-img-en.png';
import fiImg from '../../assets/signup-intro-img-fi.png';

const SignupProviderIntroStep = props => {
  const { onSubmit, intl, rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);
  const locale = config.locale || 'fi';

  const heading = intl.formatMessage({ id: 'SignupProviderForms.introHeading' });
  const description = intl.formatMessage({ id: 'SignupProviderForms.introDescription' });
  const nextButtonText = intl.formatMessage({ id: 'SignupProviderForms.nextButton' });
  const exampleProfileText = intl.formatMessage({ id: 'SignupProviderForms.exampleProfileText' });
  const exampleProfileId = '60376c8c-40aa-4cdb-8a66-70fd554dc744';

  const imageSrc = locale === 'en' ? enImg : fiImg;

  return (
    <div className={classes}>
      <div className={css.form}>
        <div className={css.formFieldsContainer}>
          <div className={css.introContainer}>
            <div className={css.infoDescription}>
              <h2 className={css.mainHeading}>{heading}</h2>
              <p className={css.description}>{description}</p>
              <NamedLink
                className={css.exampleProfileLink}
                name="ProfilePage"
                params={{ id: exampleProfileId }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {exampleProfileText}
              </NamedLink>
            </div>
            <div className={css.introImageContainer}>
              <img src={imageSrc} alt="Signup Intro" className={css.introImage} />
            </div>
          </div>
        </div>

        <div className={css.submitContainerNoHeading}>
          <Button rootClassName={css.nextButton} onClick={onSubmit}>
            {nextButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SignupProviderIntroStep);
